export const companyTemplatesSeed = Array.from({ length: 14 }, (_, i) => ({
  id: `ctpl-${i}`,
  name: `Reminder — ${['Teams', 'WhatsApp', 'Email'][i % 3]} (${i + 1})`,
  scope: i % 4 === 0 ? 'Company' : 'Department',
  language: ['en', 'ar', 'fr'][i % 3],
  basedOnGlobalId: `gtpl-${i % 5}`,
  basedOnGlobalName: `Global Template ${i % 5}`,
  version: `${1 + (i % 3)}.${i % 2}`,
  status: i % 9 === 0 ? 'archived' : 'active',
  channel: ['teams', 'whatsapp', 'email'][i % 3],
  type: ['Reminder', 'MOM', 'Booking'][i % 3],
  hasOverride: i % 4 === 1,
}));

export function companyTemplateDetailSeed(id, isNew) {
  if (isNew) {
    return {
      id: null,
      name: '',
      scope: 'Company',
      channel: 'teams',
      type: 'Reminder',
      lockedFields: ['footerLegal', 'unsubscribeBlock'],
      languages: {
        en: { subject: '', bodyMarkdown: '# Hello\n\n{{meeting_title}}', rtl: false },
        ar: { subject: '', bodyMarkdown: '', rtl: true },
        fr: { subject: '', bodyMarkdown: '', rtl: false },
      },
      status: 'draft',
      basedOnGlobalId: null,
      hasOverride: false,
    };
  }
  return {
    id,
    name: `Company template ${id}`,
    scope: 'Company',
    channel: 'teams',
    type: 'Reminder',
    lockedFields: ['footerLegal', 'unsubscribeBlock'],
    languages: {
      en: {
        subject: 'Reminder: {{meeting_title}}',
        bodyMarkdown: '# Meeting reminder\n\nHello {{first_name}},\n\n**{{meeting_title}}** at {{start_time}}.',
        rtl: false,
      },
      ar: {
        subject: 'تذكير: {{meeting_title}}',
        bodyMarkdown: '# تذكير الاجتماع\n\nمرحبا {{first_name}}',
        rtl: true,
      },
      fr: {
        subject: '',
        bodyMarkdown: '',
        rtl: false,
      },
    },
    status: 'active',
    basedOnGlobalId: 'gtpl-0',
    basedOnGlobalName: 'Global Template 0',
    hasOverride: id.includes('1'),
    version: '2.1',
  };
}
